import React from "react";
import { Link } from "react-router";
import { MapPin, MessageSquare, Send } from "lucide-react";

export default function EnquireSidebar({ fieldOfStudy, universityName }) {
  return (
    <div
      id="interested-uni"
      className="shadow-lg shadow-gray-300 rounded-2xl p-4 border border-gray-300 text-left flex flex-col gap-4 h-fit"
    >
      <h3 className="text-xl font-bold flex flex-col items-center text-center">
        Interested in
        <span className="text-center"> {fieldOfStudy} </span>
        from {universityName}?
      </h3>
      <div className="flex gap-4 w-full">
        <div className="flex flex-col gap-4 w-full items-center">
          <Link
            to="/form"
            className=" border h-20 flex gap-2 items-center justify-center  p-1 rounded-lg hover:bg-amber-400 hover:text-white"
          >
            <MessageSquare className="w-10 h-10" />
            <div className="text-sm">
              <p>This is one of my choice</p>
              <p>Help me Analyse and Compare</p>
            </div>
          </Link>
          <Link
            to="/form"
            state={{ formType: "campusVisit" }}
            className="border h-20 flex gap-2 items-center justify-center p-1 rounded-lg hover:bg-amber-400 hover:text-white"
          >
            <MapPin className="w-10 h-10" />
            <div className="text-sm">
              <p>Visit and explore in-person</p>
              <p>Book campus tour</p>
            </div>
          </Link>
          <Link
            to="/form"
            className="border h-20 flex gap-2 items-center justify-center p-1 rounded-lg hover:bg-amber-400 hover:text-white"
          >
            <Send className="w-10 h-10" />
            <div className="text-sm">
              <p>I'm ready to apply</p>
              <p>Start my priority registration</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
